import * as React from 'react';
const SvgWaveOneMobile = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 375 135"
    fill="none"
    {...props}
    style={{ marginTop: '-1px' }}
  >
    <g clipPath="url(#header_wave_mob_svg__a)">
      <path
        fill="url(#header_wave_mob_svg__b)"
        d="M584.028 141.063c-80.38-12-216.357-77.853-375.799-69.187-159.443 8.667-229.875 103.167-388 112-158.125 8.834-225.875-73.666-384-75-158.125-1.333-264.52 129.22-376.525 67.386-112.004-61.833-540.264-191.533-158.124-347.199 382.134-155.667 1577.295-316.667 1992.373-400"
        opacity={0.05}
      />
      <path
        fill="url(#header_wave_mob_svg__c)"
        d="M584.029 115.063c-80.381-12-226.383-66.267-385.825-57.6-159.443 8.666-221.375 90.366-379.5 99.2-158.125 8.833-221.375-55.467-379.5-56.8-158.125-1.334-267.495 112.233-379.5 50.4-112.004-61.834-540.264-191.534-158.124-347.2 382.134-155.667 1577.296-316.667 1992.374-400"
        opacity={0.53}
      />
      <path
        fill="url(#header_wave_mob_svg__d)"
        d="M583.031 76.063c-80.381-12-185.357-82.853-344.8-74.187-159.442 8.667-264.877 122.167-423.002 131-158.125 8.834-218.9-70.68-377.025-72.013-158.125-1.334-267.495 112.233-379.5 50.4-112.004-61.834-618.344-809.534-236.214-965.2C-795.372-1009.6 477.876-978.667 892.954-1062"
      />
    </g>
    <defs>
      <linearGradient
        id="header_wave_mob_svg__b"
        x1={-106502}
        x2={-106502}
        y1={196.698}
        y2={-76367.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3896B2" />
      </linearGradient>
      <linearGradient
        id="header_wave_mob_svg__c"
        x1={-106502}
        x2={-106502}
        y1={168.698}
        y2={-76395.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3896B2" />
      </linearGradient>
      <linearGradient
        id="header_wave_mob_svg__d"
        x1={-106502}
        x2={-106502}
        y1={140.698}
        y2={-76423.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006B99" />
        <stop offset={1} stopColor="#3896B2" />
      </linearGradient>
      <clipPath id="header_wave_mob_svg__a">
        <path fill="#fff" d="M375 135H0V0h375z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWaveOneMobile;
